import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { EmployerCompanyInformationForm } from 'src/components/employer';
import { useEmployerById, useEmployerParamId } from 'src/hooks/employer';

export const EmployerCompanyInformationPage: React.FC = () => {
  const employerId = useEmployerParamId();
  const { employer } = useEmployerById(employerId);

  return (
    <DetailPageLayout titleContent="Company Information">
      <EmployerCompanyInformationForm employer={employer} />
    </DetailPageLayout>
  );
};
